import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkTokenValidity, fetchEntitlements } from "./api";
import { useSweetAlert } from "context/sweet_alert";
import { AppContext } from "context";

const UNAUTHORIZED_EVENT = "app:unauthorized";

export const AuthMiddleware = ({ children }) => {
  const { showAlert } = useSweetAlert();
  const { setUser, setBusiness, setEntitlements, setPlan } = useContext(AppContext);
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [valid, setValid] = useState(false);
  const alertLockRef = useRef(false);

  useEffect(() => {
    const handleUnauthorized = (event) => {
      const isLoginRoute = window.location.pathname === "/login";
      const detail = event?.detail || {};

      setUser(null);
      setBusiness(null);

      if (!alertLockRef.current && !detail.silent) {
        alertLockRef.current = true;
        showAlert({
          title: "Atencao",
          text:
            detail.message ||
            "Sua sessao expirou, faca login novamente.",
          icon: "error",
          timer: 5000,
        });
        setTimeout(() => {
          alertLockRef.current = false;
        }, 5000);
      }

      if (!isLoginRoute) {
        navigate("/login", { replace: true });
      }
    };

    document.addEventListener(UNAUTHORIZED_EVENT, handleUnauthorized);
    return () => {
      document.removeEventListener(UNAUTHORIZED_EVENT, handleUnauthorized);
    };
  }, [navigate, setBusiness, setUser, showAlert]);

  useEffect(() => {
    let mounted = true;

    const validate = async () => {
      const result = await checkTokenValidity();
      if (!mounted) return;

      const isValid = !!result.valid;
      setValid(isValid);
      setChecking(false);

      if (isValid) {
        if (result.user) {
          setUser(result.user);
        }
        if (Object.prototype.hasOwnProperty.call(result, "empresa")) {
          setBusiness(result.empresa || null);
        }
        // carrega entitlements do tenant
        try {
          const ents = await fetchEntitlements();
          if (ents) {
            setEntitlements(ents.entitlements || null);
            setPlan(ents.plan || null);
          }
        } catch {}
        return;
      }

      const detail = {
        source: "middleware",
        message:
          result.reason === "expired"
            ? "Sua sessao expirou, faca login novamente."
            : result.reason === "missing_cookie"
              ? "O navegador nao aceitou o cookie da sessao. Verifique o dominio e o HTTPS."
              : result.reason === "session_not_found"
                ? "A sessao nao foi encontrada no banco de dados."
                : "Nao foi possivel validar sua sessao.",
      };

      document.dispatchEvent(new CustomEvent(UNAUTHORIZED_EVENT, { detail }));
    };

    validate();

    return () => {
      mounted = false;
    };
  }, [setUser, setBusiness, setEntitlements, setPlan]);

  if (checking) return null;
  return valid ? children : null;
};
